import { EmptyState } from "@/components/ui/empty-state";
import * as Sentry from "@sentry/react";
import { Box, Link, Text } from "@chakra-ui/react";
import { AiOutlineFrown } from "react-icons/ai";
import { useRouteError } from "react-router-dom";

const Error = () => {
  const error = useRouteError();
  console.error(error);
  Sentry.captureException(error);

  return (
    <EmptyState icon={<AiOutlineFrown />} title="Oh Dear..." size="lg">
      <Box textAlign="center">
        <Text fontSize="lg" p={0} m={0}>
          {error.status}
          {error.status && <>:</>} We apologize for the inconvenience. <strong>{error.message}</strong>
        </Text>
        <Text fontSize="sm">
          If you require further assistance, please contact our support team at{" "}
          <Link href="mailto:support@gplanharmony.com" color="blue.500">
            support@planharmony.com
          </Link>
          .
        </Text>
      </Box>
    </EmptyState>
  );
};
export default Error;
